module.exports = __webpack_public_path__ + "static/img/img_map_02.2d73657.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dali/img_map_02.png
// module id = 7Pa8
// module chunks = 19